import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

// ====================
// Caris service request — shared
// ====================

export const CarisServiceRequestStateSchema = z.enum(['NEW', 'ACCEPTED', 'COMPLETED', 'CANCELLED']);

export type CarisServiceRequestState = z.infer<typeof CarisServiceRequestStateSchema>;

export const VehicleCarisServiceRequestSchema = z.object({
  id: z.string(),
  state: CarisServiceRequestStateSchema,
  description: z.string(),
  createdAt: z.string(),
  branch: z.object({id: z.string(), title: z.string()}).nullable(),
  createdBy: z.object({id: z.string(), name: z.string().nullable()}),
  updatedAt: z.string(),
});

export type VehicleCarisServiceRequest = z.infer<typeof VehicleCarisServiceRequestSchema>;

// ====================
// GET /dms/v1/caris/vehicle-service-request
// ====================

export const GetVehicleCarisServiceRequestsApiArgSchema = z.object({
  vehicleId: z.string(),
  state: z.array(CarisServiceRequestStateSchema).optional(),
});

export type GetVehicleCarisServiceRequestsApiArg = z.infer<
  typeof GetVehicleCarisServiceRequestsApiArgSchema
>;

export const GetVehicleCarisServiceRequestsApiResponseSchema = z.object({
  items: z.array(VehicleCarisServiceRequestSchema),
});

export type GetVehicleCarisServiceRequestsApiResponse = z.infer<
  typeof GetVehicleCarisServiceRequestsApiResponseSchema
>;

// ====================
// POST /dms/v1/caris/service-request
// ====================

export const CreateCarisServiceRequestRequestBodySchema = z.object({
  vehicleId: z.string(),
  description: z.string(),
});

export type CreateCarisServiceRequestRequestBody = z.infer<
  typeof CreateCarisServiceRequestRequestBodySchema
>;

export const CreateCarisServiceRequestApiArgSchema = z.object({
  body: CreateCarisServiceRequestRequestBodySchema,
});

export type CreateCarisServiceRequestApiArg = z.infer<typeof CreateCarisServiceRequestApiArgSchema>;

export const CreateCarisServiceRequestApiResponseSchema = z.object({
  id: z.string(),
});

export type CreateCarisServiceRequestApiResponse = z.infer<
  typeof CreateCarisServiceRequestApiResponseSchema
>;

// ====================
// PUT /dms/v1/caris/service-request/{serviceRequestId}/cancel
// ====================

export const CancelCarisServiceRequestApiArgSchema = z.object({
  serviceRequestId: z.string(),
  // Not sent; identifies the vehicle list to refetch
  vehicleId: z.string(),
});

export type CancelCarisServiceRequestApiArg = z.infer<typeof CancelCarisServiceRequestApiArgSchema>;

export const CancelCarisServiceRequestApiResponseSchema = BaseVoidResponseSchema;

export type CancelCarisServiceRequestApiResponse = z.infer<
  typeof CancelCarisServiceRequestApiResponseSchema
>;
